import React from 'react';
import BaseInputWidget from './BaseInputWidget';

const PasswordWidget = props => {
    return <BaseInputWidget type="password" {...props} />;
};

export default PasswordWidget;
